<template>
    <div class="tr mp-promos__product">
        <div
            class="mp-promos__productWrapper"
            :id="`mp-promos__productWrapper-${product.id}`"
        >
            <div v-if="product.main === false" class="tr__upper align-items-center gap-1">
                <div class="tr__primary">
                    <div class="tr-featured gap-0-5 align-items-center">
                        <div class="tr-featured__details">
                            <span class="typo typo--label">EAN: {{ product.ean }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="tr__upper align-items-center gap-1">
                <div class="tr__primary">
                    <div class="tr-featured gap-0-5 align-items-center">
                        <div
                            class="tr-featured__image--product d-flex
                                align-items-center justify-items-center"
                        >
                            <img
                                :src="product.dict_product.image.urls.small"
                                class="img-fluid"
                            />
                        </div>
                        <div class="tr-featured__details">
                            <span class="typo typo--label">EAN: {{ product.dict_product.ean }}</span>
                            <p class="typo typo--name">
                                {{ product.dict_product.name }}
                            </p>
                        </div>
                    </div>
                </div>

                <div
                    v-if="
                        promoType !== PROMO_TYPES.SALES_TARGET &&
                            (!isBonded || (isBonded && !isSetTrigger(productSet)))
                    "
                    class="tr__secondary tr-data is-column ml-0 typo--sm"
                >
                    <div class="tr-data__cell">
                        <span class="tr-data__dt">Zwrot netto</span>
                        <span
                            class="tr-data__dd"
                            v-if="sumRefund(product) !== 0"
                        >
                            {{ sumRefund(product) | currency(promoType) }}
                        </span>
                        <span class="tr-data__dd" v-else>---</span>
                    </div>
                    <div
                        v-if="
                            promoType !== PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION &&
                                promoType !== PROMO_TYPES.WEIGHT_REGULAR_PRICE &&
                                !isBonded
                        "
                        class="tr-data__cell"
                    >
                        <span class="tr-data__dt" v-text="'Min. liczba'" />
                        <span class="tr-data__dd" v-text="minAmount" />
                    </div>
                    <div
                        v-if="promoType === PROMO_TYPES.QUOTA"
                        class="tr-data__cell"
                    >
                        <span class="tr-data__dt">Rabat brutto</span>
                        <span class="tr-data__dd">{{ -product.discount_amount | currency }}</span>
                    </div>
                    <div
                        v-if="
                            product.maximum_price !== undefined &&
                                !product.percentage_discount &&
                                showMaxPrice
                        "
                        class="tr-data__cell"
                    >
                        <span class="tr-data__dt">Max. cena</span>
                        <span
                            v-if="product.maximum_price"
                            class="tr-data__dd"
                        >
                            {{ product.maximum_price | currency(promoType) }}
                        </span>
                        <span v-else class="tr-data__dd">---</span>
                    </div>
                    <!-- Cena hurtowa (max. marża) ECD-->
                    <div class="tr-data__cell" v-if="isMargin && !isBonded">
                        <span class="tr-data__dt d-flex">Max cena hurt. ECD (marża %)
                            <a-icon
                                icon="Info"
                                width="14px"
                                height="14px"
                                class="text-dark ml-1"
                                style="transform: translateY(2px)"
                                v-tooltip="wholesalePriceMarginTooltip('ECD')"
                            />
                        </span>
                        <span class="tr-data__dd">
                            <span v-if="product.wholesale_price_distribution">
                                {{ product.wholesale_price_distribution | currency }}
                            </span>
                            <span v-else>b/d</span>
                            ({{
                                $functions.calculateMargin({
                                    product,
                                    productSet,
                                    wholesaleType:
                                        'wholesale_price_distribution'
                                })
                            }})
                        </span>
                    </div>
                    <!-- Cena hurtowa (max. marża) ECC-->
                    <div class="tr-data__cell" v-if="isMargin && !isBonded">
                        <span class="tr-data__dt d-flex">Max cena hurt. ECC (marża %)
                            <a-icon
                                icon="Info"
                                width="14px"
                                height="14px"
                                class="text-dark ml-1"
                                style="transform: translateY(2px)"
                                v-tooltip="wholesalePriceMarginTooltip('ECC')"
                            />
                        </span>
                        <span class="tr-data__dd">
                            <span v-if="product.wholesale_price_cash_and_carry">
                                {{ product.wholesale_price_cash_and_carry | currency }}
                            </span>
                            <span v-else>b/d</span>
                            ({{
                                $functions.calculateMargin({
                                    product,
                                    productSet,
                                    wholesaleType:
                                        'wholesale_price_cash_and_carry'
                                })
                            }})
                        </span>
                    </div>
                    <!-- Cena hurtowa (max. marża) DZ-->
                    <div class="tr-data__cell" v-if="isMargin && !isBonded">
                        <span class="tr-data__dt d-flex">Max cena hurt. DZ (marża %)
                            <a-icon
                                icon="Info"
                                width="14px"
                                height="14px"
                                class="text-dark ml-1"
                                style="transform: translateY(2px)"
                                v-tooltip="wholesalePriceMarginTooltip('DZ')"
                            />
                        </span>
                        <span class="tr-data__dd">
                            <span v-if="product.wholesale_price_external_distribution">
                                {{ product.wholesale_price_external_distribution | currency }}
                            </span>
                            <span v-else>b/d</span>
                            ({{
                                $functions.calculateMargin({
                                    product,
                                    productSet,
                                    wholesaleType:
                                        'wholesale_price_external_distribution'
                                })
                            }})
                        </span>
                    </div>
                </div>
                <div
                    v-else-if="promoType === PROMO_TYPES.SALES_TARGET"
                    class="tr__secondary tr-data is-column ml-0 typo--sm"
                >
                    <div class="tr-data__cell">
                        <span class="tr-data__dt">Nagroda netto</span>
                        <span class="tr-data__dd">
                            {{ totalRefund }}
                        </span>
                    </div>
                    <div
                        v-for="(threshold, idx) in promotion.salesTargetThresholds"
                        class="tr-data__cell"
                        :key="`threshold-${idx}`"
                    >
                        <span class="tr-data__dt">
                            Próg {{ ++idx }} (nagroda)
                            <a-icon
                                icon="Info"
                                width="14px"
                                height="14px"
                                class="text-dark ml-1"
                                style="transform: translateY(2px)"
                                v-tooltip="`Liczba sztuk w ramach danego progu
                                oraz wartość nagrody za osiągnięcie progu`"
                            />
                        </span>
                        <span class="tr-data__dd">
                            {{ threshold.target }} szt.
                            ({{ threshold.prize_amount | currency(promoType) }})
                        </span>
                    </div>
                </div>
            </div>
            <slot name="showMoreBtn"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import promoBonded from '@/mixins/promoBonded'
import { sumRefund } from '@/helpers/product'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    mixins: [promoBonded],
    props: {
        product: {
            type: Object,
            required: true
        },
        showMaxPrice: {
            type: Boolean,
            default: true
        },
        promotion: {
            type: Object,
            required: true
        },
        productSet: {
            type: Object,
            required: false
        }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        promoType() {
            return this.promotion.type
        },
        isMargin() {
            return this.$store.getters.isMarginType(this.promotion.type)
        },
        setWeight() {
            // eslint-disable-next-line camelcase
            return this.productSet?.required_weight
        },
        minAmount() {
            if (this.setWeight) {
                return Math.ceil(this.setWeight / this.product.weight) + ' szt.'
            }

            return this.product.count || 1 + ' szt.'
        },
        totalRefund() {
            return this.$functions.calculateRefund(this.promotion)
        }
    },
    methods: {
        wholesalePriceMarginTooltip(code) {
            return this.$store.getters.getWholesalePriceMarginTooltip(code)
        },
        sumRefund
    }
}
</script>
